export enum RegistrationType {
  None = 0,
  BAFA = 1, // Bundesamt für Wirtschaft und Ausfuhrkontrolle
  Dena = 2, // Deutsche Energie-Agentur GmbH (dena)
  Debitor = 3, // Debitor
  VAT = 4, // Umsatzsteuer-Identifikationsnummer
  CustomerReference = 5, // Kundenreferenz
  LID = 6,
}
